import React from "react";
import { Button } from "antd";
import Swal from "sweetalert2";
import { whatMap } from "../../devdata/maps/whatmap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const DemoButton = ({ what }) => {
  const navigate = useNavigate();
  // Fallback in case "what" is not in the map
  const { title, desc, video } = whatMap[what] || {
    title: "Unknown",
    desc: "No description available.",
    video: "",
  };

  const handleButtonClick = () => {
    navigate("/Learn");
  };

  return (
    <div
      onClick={handleButtonClick}
      className="bg-darkMode-layer2 text-darkMode-text flex items-center text-sm px-3 py-3 rounded-xl shadow-md transition-all duration-300 ease-in-out hover:ring-2 hover:ring-darkMode-green cursor-pointer"
    // onClick={() => setSearchVisible(true)} // Show the input
    >
      Demo
      <FontAwesomeIcon icon={faPlay} className="ml-2" />
    </div>
  );
};

export default DemoButton;
